export function authHeader() {
    // return authorization header with basic auth credentials
    let companyUser = JSON.parse(localStorage.getItem('companyUser'));

    if (companyUser && companyUser.authdata) {
        return { 'Authorization': 'Basic ' + companyUser.authdata };
    } else {
        return {};
    }
}

export function noUserPostHeader() {
        return { 'Content-Type': 'application/json'} 
}

export function authHeaderAJ(contentType='application/json') {
    // return authorization header with basic auth credentials
    let companyUser = JSON.parse(localStorage.getItem('companyUser'));

    if (companyUser && companyUser.authdata) {
        return { 'Content-Type': contentType, 
                'Authorization': 'Basic ' + companyUser.authdata };
    } else {
        return {};
    }
}

